import { showToast } from "@/api/notification";
import { useGeneralApiCall } from "@/services/useGeneralApiCall";
import React, { SetStateAction, useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const RestoreStyle: React.FC = () => {
  const [styles, setStyles] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<{ [key: string]: boolean }>({});
  const navigate = useNavigate();

  const { getApi, postApi } = useGeneralApiCall();

  const fetchData = async () => {
    try {
      const response = await getApi<SetStateAction<any[]>>(
        "/api/style/v1/get-deleted-styles/"
      );
      setStyles(response.data);
    } catch (error: any) {
      showToast({ message: error.message, type: "error" });
    }
  };
  const handleRestore = async (styleId: string) => {
    try {
      setIsLoading((prev) => ({ ...prev, [styleId]: true }));
      const res = await postApi(
        `/api/style/v1/restore-deleted-style/${styleId}/`
      );

      if (res.status === 200) {
        toast.success(res.message || `Style Restored Successfully!`);
      }

      // Refresh the list after successful restore
      await fetchData();
    } catch (error) {
      console.error("Error restoring style:", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, [styleId]: false }));
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="permission-container">
      {styles.length === 0 ? (
        <Alert variant="info" className="text-center">
          No deleted styles found.
        </Alert>
      ) : (
        <table className="permission-table">
          <thead>
            <tr>
              <th>Style Name</th>
              <th>Active</th>
            </tr>
          </thead>
          <tbody>
            {styles.map((style) => (
              <tr key={style.style_id}>
                <td
                  onClick={() => navigate(`/style/details/${style.style_id}`)}
                  className="cursor-pointer"
                >
                  {style.name}
                </td>
                <td>
                  <label className="switch">
                    <button
                      onClick={() => handleRestore(style.style_id)}
                      disabled={isLoading[style.style_id]}
                      className="btn btn-primary"
                    >
                      Restore
                    </button>
                  </label>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default RestoreStyle;
